import { render, staticRenderFns } from "./cabinet.vue?vue&type=template&id=3e82b235&scoped=true&"
import script from "./cabinet.vue?vue&type=script&lang=js&"
export * from "./cabinet.vue?vue&type=script&lang=js&"
import style0 from "./cabinet.vue?vue&type=style&index=0&id=3e82b235&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e82b235",
  null
  
)

export default component.exports